export default "__VITE_ASSET__DBxV8EHt__"